export default __webpack_public_path__ + "static/media/about-2.ff18bddb.svg";